import React from 'react';
import MinimalFleetMap from '../components/MinimalFleetMap';

const MapPage: React.FC = () => {
  console.log('🗺️ MapPage rendering MinimalFleetMap');
  return <MinimalFleetMap />;
};

export default MapPage;